
























import { defineComponent, ref, watch } from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import { moduleList } from '@/views/Report/Management/management-router';
import useAuth from '@/useAuth';

const Index = defineComponent({
  setup() {
    const { route } = useRouter();
    const { hasPermission } = useAuth();

    return {
      hasPermission,
      moduleList,
    };
  },
});

export default Index;
